import React from 'react'
import PropTypes from 'prop-types'

import UploadVideoCreativeRoute from './UploadVideoCreativeRoute'

import {
  VIDEO_EXISTING_LIBRARY_TYPE,
  VIDEO_EXTERNAL_HOST_TYPE,
  VIDEO_UPLOAD_TYPE,
  VIDEO_VAST_XML_TYPE
} from '../../fields'

const VideoRoutes = ({ selectedRoute, ...otherProps }) => {
  switch (selectedRoute) {
    case VIDEO_UPLOAD_TYPE:
      return <UploadVideoCreativeRoute {...otherProps} />
    case VIDEO_EXTERNAL_HOST_TYPE:
      return <>'VIDEO_EXTERNAL_HOST_TYPE'</>
    case VIDEO_VAST_XML_TYPE:
      return <>'VIDEO_VAST_XML_TYPE'</>
    case VIDEO_EXISTING_LIBRARY_TYPE:
    default:
      return <>'VIDEO_EXISTING_LIBRARY_TYPE'</>
  }
}

VideoRoutes.propTypes = {
  selectedRoute: PropTypes.string.isRequired
}

export default VideoRoutes
